import Hero from "@/components/Webpage/Hero";
import Features from "@/components/Webpage/Features"; 
import FAQ from "@/components/Webpage/FAQ";
import Footer from './../components/Webpage/Footer';
export default function Home() {
  return (
    <>
      <Hero />
      {/* <Solutions /> */}
      <Features />
      <FAQ />
      {/* <Contact /> */}
      <Footer />
    </>
  );
}
